import IDetailsCredits from "../Abstraction/IDetailsCredits";
import videoTile from "../Assets/home/main-tile.png";
import details1Image1 from "../Assets/dataImages/details/details-1-image-1.jpg";
import details1Image2 from "../Assets/dataImages/details/details-1-image-2.jpg";
import details1Image3 from "../Assets/dataImages/details/details-1-image-3.jpg";
import details1Image4 from "../Assets/dataImages/details/details-1-image-4.jpg";
import details1Image5 from "../Assets/dataImages/details/details-1-image-5.png";
import details1Image6 from "../Assets/dataImages/details/details-1-image-6.jpg";
import details1Image7 from "../Assets/dataImages/details/details-1-image-7.jpg";
import details1Image8 from "../Assets/dataImages/details/details-1-image-8.jpg";
import details1Image9 from "../Assets/dataImages/details/details-1-image-9.jpg";

import details2Image1 from "../Assets/dataImages/details/details-2-image-1.jpg";
import details2image2 from "../Assets/dataImages/details/details-2-image-2.jpg";
import details2image3 from "../Assets/dataImages/details/details-2-image-3.jpg";

import details3Image1 from "../Assets/dataImages/details/details-3-image-1.jpg";
import details3image2 from "../Assets/dataImages/details/details-3-image-2.jpg";
import details3image3 from "../Assets/dataImages/details/details-3-image-3.jpg";

import details4Image1 from "../Assets/dataImages/details/details-4-image-1.jpg";
import details4image2 from "../Assets/dataImages/details/details-4-image-2.jpg";
import details4image3 from "../Assets/dataImages/details/details-4-image-3.jpg";

import details5Image1 from "../Assets/dataImages/details/details-5-image-1.jpg";
import details5image2 from "../Assets/dataImages/details/details-5-image-2.jpg";
import details5image3 from "../Assets/dataImages/details/details-5-image-3.jpg";

import details6Image1 from "../Assets/dataImages/details/details-6-image-1.jpg";
import details6image2 from "../Assets/dataImages/details/details-6-image-2.jpg";
import details6image3 from "../Assets/dataImages/details/details-6-image-3.jpg";

import details7Image1 from "../Assets/dataImages/details/details-7-image-1.jpg";
import details7image2 from "../Assets/dataImages/details/details-7-image-2.jpg";
import details7image3 from "../Assets/dataImages/details/details-7-image-3.jpg";

import details8Image1 from "../Assets/dataImages/details/details-8-image-1.jpg";
import details8image2 from "../Assets/dataImages/details/details-8-image-2.jpg";
import details8image3 from "../Assets/dataImages/details/details-8-image-3.jpg";

import details9Image1 from "../Assets/dataImages/details/details-9-image-1.jpg";
import details9image2 from "../Assets/dataImages/details/details-9-image-2.jpg";
import details9image3 from "../Assets/dataImages/details/details-9-image-3.jpg";

import details10Image1 from "../Assets/dataImages/details/details-10-image-1.jpg";
import details10Image2 from "../Assets/dataImages/details/details-10-image-2.jpg";
import details10image3 from "../Assets/dataImages/details/details-10-image-3.jpg";
import details10image4 from "../Assets/dataImages/details/details-10-image-4.jpg";
import details10image5 from "../Assets/dataImages/details/details-10-image-5.jpg";
import details10image6 from "../Assets/dataImages/details/details-10-image-6.jpg";

import details11Image1 from "../Assets/dataImages/details/details-11-image-1.jpg";
import details11image2 from "../Assets/dataImages/details/details-11-image-2.jpg";
import details11image3 from "../Assets/dataImages/details/details-11-image-3.jpg";

import details12Image1 from "../Assets/dataImages/details/details-12-image-1.jpg";
import details12image2 from "../Assets/dataImages/details/details-12-image-2.jpg";
import details12image3 from "../Assets/dataImages/details/details-12-image-3.jpg";
import details12image4 from "../Assets/dataImages/details/details-12-image-4.jpg";

import details13Image1 from "../Assets/dataImages/details/details-13-image-1.jpg";
import details13image2 from "../Assets/dataImages/details/details-13-image-2.jpg";
import details13image3 from "../Assets/dataImages/details/details-13-image-3.jpg";

import details14Image1 from "../Assets/dataImages/details/details-14-image-1.jpg";
import details14image2 from "../Assets/dataImages/details/details-14-image-2.jpg";
import details14image3 from "../Assets/dataImages/details/details-14-image-3.jpg";

import details15Image1 from "../Assets/dataImages/details/details-15-image-1.jpg";
import details15image2 from "../Assets/dataImages/details/details-15-image-2.jpg";
import details15image3 from "../Assets/dataImages/details/details-15-image-3.jpg";

import details16Image1 from "../Assets/dataImages/details/details-16-image-1.jpg";
import details16image2 from "../Assets/dataImages/details/details-16-image-2.jpg";
import details16image3 from "../Assets/dataImages/details/details-16-image-3.jpg";
import details16image4 from "../Assets/dataImages/details/details-16-image-4.jpg";

import details17Image1 from "../Assets/dataImages/details/details-17-image-1.jpg";
import details17image2 from "../Assets/dataImages/details/details-17-image-2.jpg";
import details17image3 from "../Assets/dataImages/details/details-17-image-3.jpg";

import details18Image1 from "../Assets/dataImages/details/details-18-image-1.jpg";
import details18image2 from "../Assets/dataImages/details/details-18-image-2.jpg";
import details18image3 from "../Assets/dataImages/details/details-18-image-3.jpg";

import details19Image1 from "../Assets/dataImages/details/details-19-image-1.jpg";
import details19image2 from "../Assets/dataImages/details/details-19-image-2.jpg";
import details19image3 from "../Assets/dataImages/details/details-19-image-3.jpg";
import details19image4 from "../Assets/dataImages/details/details-19-image-4.jpg";
import details19image5 from "../Assets/dataImages/details/details-19-image-5.jpg";

import details20Image1 from "../Assets/dataImages/details/details-20-image-1.jpg";
import details20image2 from "../Assets/dataImages/details/details-20-image-2.jpg";
import details20image3 from "../Assets/dataImages/details/details-20-image-3.jpg";
import details20image4 from "../Assets/dataImages/details/details-20-image-4.jpg";
import details20image5 from "../Assets/dataImages/details/details-20-image-5.jpg";

import details21Image1 from "../Assets/dataImages/details/details-21-image-1.jpg";
import details21image2 from "../Assets/dataImages/details/details-21-image-2.jpg";
import details21image3 from "../Assets/dataImages/details/details-21-image-3.jpg";
import details21image4 from "../Assets/dataImages/details/details-21-image-4.jpg";
import details21image5 from "../Assets/dataImages/details/details-21-image-5.jpg";

import details22Image1 from "../Assets/dataImages/details/details-22-image-1.jpg";
import details22image2 from "../Assets/dataImages/details/details-22-image-2.jpg";
import details22image3 from "../Assets/dataImages/details/details-22-image-3.jpg";
import details22image4 from "../Assets/dataImages/details/details-22-image-4.jpg";
import details22image5 from "../Assets/dataImages/details/details-22-image-5.jpg";
import details22image6 from "../Assets/dataImages/details/details-22-image-6.jpg";
import details22image7 from "../Assets/dataImages/details/details-22-image-7.jpg";

import details23Image1 from "../Assets/dataImages/details/details-23-image-1.jpg";
import details23image2 from "../Assets/dataImages/details/details-23-image-2.jpg";
import details23image3 from "../Assets/dataImages/details/details-23-image-3.jpg";
import details23image4 from "../Assets/dataImages/details/details-23-image-4.jpg";

import details24Image1 from "../Assets/dataImages/details/details-24-image-1.jpg";
import details24image2 from "../Assets/dataImages/details/details-24-image-2.jpg";
import details24image3 from "../Assets/dataImages/details/details-24-image-3.jpg";
import details24image4 from "../Assets/dataImages/details/details-24-image-4.jpg";
import details24image5 from "../Assets/dataImages/details/details-24-image-5.jpg";
import details24image6 from "../Assets/dataImages/details/details-24-image-6.jpg";
import details24image7 from "../Assets/dataImages/details/details-24-image-7.jpg";

import details25Image1 from "../Assets/dataImages/details/details-25-image-1.jpg";
import details25Image2 from "../Assets/dataImages/details/details-25-image-2.jpg";
import details25Image3 from "../Assets/dataImages/details/details-25-image-3.jpg";

import details26Image1 from "../Assets/dataImages/details/details-26-image-1.jpg";
import details26Image2 from "../Assets/dataImages/details/details-26-image-2.jpg";
import details26Image3 from "../Assets/dataImages/details/details-26-image-3.jpg";


import details27Image1 from "../Assets/dataImages/details/details-27-image-1.jpg";
import details27Image2 from "../Assets/dataImages/details/details-27-image-2.jpg";
import details27Image3 from "../Assets/dataImages/details/details-27-image-3.jpg";

import details28Image1 from "../Assets/dataImages/details/details-28-image-1.jpg";
import details28Image2 from "../Assets/dataImages/details/details-28-image-2.jpg";
import details28Image3 from "../Assets/dataImages/details/details-28-image-3.jpg";
import details28Image4 from "../Assets/dataImages/details/details-28-image-4.jpg";
import details28Image5 from "../Assets/dataImages/details/details-28-image-5.jpg";

import details29Image1 from "../Assets/dataImages/details/details-29-image-1.jpg";
import details29Image2 from "../Assets/dataImages/details/details-29-image-2.jpg";
import details29Image3 from "../Assets/dataImages/details/details-29-image-3.jpg";
import details29Image4 from "../Assets/dataImages/details/details-29-image-4.jpg";
import details29Image5 from "../Assets/dataImages/details/details-29-image-5.jpg";
import details29Image6 from "../Assets/dataImages/details/details-29-image-6.jpg";

import details30Image1 from "../Assets/dataImages/details/details-30-image-1.jpg";
import details30Image2 from "../Assets/dataImages/details/details-30-image-2.jpg";
import details30Image3 from "../Assets/dataImages/details/details-30-image-3.jpg";
import details30Image4 from "../Assets/dataImages/details/details-30-image-4.jpg";





import shopGif from "../Assets/footer/Shop.gif";
import BalconyGif from "../Assets/footer/Balcony.gif";
import FarmakGif from "../Assets/footer/Farmak_kab_gif.gif";
import Farmak8118Gif from "../Assets/footer/Farmak8118.gif";
import LeshenkoGif from "../Assets/footer/Leshenko_gif_tv.gif";
import HarveastGif from "../Assets/footer/Harveast_gif_tv.gif";
import DecronGif from "../Assets/footer/Decron_tv_gif.gif";
import ZalishukGif from "../Assets/footer/Zalishuk_gif_tv.gif";
import ModernismGif from "../Assets/footer/Modernism_tv_gif.gif";
import TheElephantsGif from "../Assets/footer/The_elephants_gif.gif";
import HeForSheGif from "../Assets/footer/HeForShe_gif_tv.gif";
import ChernihivGif from "../Assets/footer/Chernihiv_tv_gif.gif";
import ConcordGif from "../Assets/footer/Concord_gif_tv.gif";
import GusovskyGif from "../Assets/footer/Gusovsky_gif_tv.gif";
import MrGrillGif from "../Assets/footer/Mr.Grill_tv_gif.gif";
import HolosuyGif from "../Assets/footer/Holosuy_tv_gif.gif";
import OsnovyGif from "../Assets/footer/Osnovy_tv_gif.gif";
import WhyVoteGif from "../Assets/footer/Why_vote_gif.gif";
import ShchurGif from "../Assets/footer/Shchur_gif.gif";
import BeachesGif from "../Assets/footer/Beaches_gif_tv.gif";
import OrthodoxGif from "../Assets/footer/Orthodox_gif_tv.gif";
import AcerGif from "../Assets/footer/Acer_gif_tv.gif";
import LandscapeGif from "../Assets/footer/Landscape_gif_tv.gif";
import RuffGif from "../Assets/footer/Ruff_gif_tv.gif";
import Basement341Gif from "../Assets/footer/Day_tv.gif";
import TimeschangeGif from "../Assets/footer/TC_TV_gif.gif";
import Germanising101Gif from "../Assets/footer/Germanaising.gif";
import PlaylikeagirlGif from "../Assets/footer/PLG.gif";
import SearchforaPokemonGif from "../Assets/footer/SFP.gif";
import GenerationUkraineGif from "../Assets/footer/GU_gif.gif";
import DovecotesofKyivGif from "../Assets/footer/Doves.gif";



import { IDetailsData } from "../Abstraction/IDetailsData";
import { title } from "process";

const defaultHighlights: string[] = [
  details1Image1,
  details1Image2,
  details1Image3,
];

export const details: IDetailsData[] = [
  {
    id: 1,
    movie: "368517172",
    trailers: [
      {
        title: "Trailer",
        video: "421066212",
      },
    ],
    credits: [
      { title: "Year", text: "2020" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Enter Through The Balcony is a Documentary Short about Ukrainian make-shift balconies. The film explores the phenomenon of the balcony as a small architectural form. Enter Through The Balcony is a journey through the decades. It is a look inside balconies and their owners in cities across Ukraine. It is a balanced and in depth view of the balconies from their owners, employees of city councils, historians, sociologists, urbanists, developers and architects. Through the history of the balconies film explores the history of Post-Soviet Ukraine — life, culture, and the relationships between personal and public space in cities.

    An engaging love letter to Ukraine and its people, Enter Through the Balcony examines how architecture can be a curious pathway to a deeper understanding of culture and place.

    Supported by the Ukrainian Cultural Foundation.
    
    `,
    highlights: [
      details1Image1,
      details1Image2,
      details1Image3,
      details1Image4,
      details1Image5,
      details1Image6,
      details1Image7,
      details1Image8,
      details1Image9,
    ],
    tvImage: BalconyGif,
  },
  {
    id: 2,
    movie: "390444142",
    credits: [
      { title: "Year", text: "2019" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Commercial for Farmak.`,
    highlights: [details2Image1, details2image2, details2image3],
    tvImage: FarmakGif, // Replace this with correct tv image
  },
  {
    id: 3,
    movie: "247482780",
    credits: [
      { title: "Year", text: "2017" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Commercial for Farmak.`,
    highlights: [details3Image1, details3image2, details3image3],
    tvImage: Farmak8118Gif,
  },
  {
    id: 4,
    movie: "390435168",
    credits: [
      { title: "Year", text: "2019" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Political campaign ad for Serhiy Leshchenko for the Ukrainian 2019 Parliamentary election.`,
    highlights: [details4Image1, details4image2, details4image3],
    tvImage: LeshenkoGif,
  },
  {
    id: 5,
    movie: "329754271",
    credits: [
      { title: "Year", text: "2018" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Commercial for Harveast.`,
    highlights: [details5Image1, details5image2, details5image3],
    tvImage: HarveastGif,
  },
  {
    id: 6,
    movie: "314021999",
    credits: [
      { title: "Year", text: "2019" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Commercial for Decron Club. Decron Club created the first Space Coin opening a new era of collectible coins.`,
    highlights: [details6Image1, details6image2, details6image3],
    tvImage: DecronGif,
  },
  {
    id: 7,
    movie: "388999331",
    credits: [
      { title: "Year", text: "2019" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Political campaign ad for Svitlana Zalishchuk for the Ukrainian 2019 Parliamentary election.`,
    highlights: [details7Image1, details7image2, details7image3],
    tvImage: ZalishukGif,
  },
  {
    id: 8,
    movie: "274901531",
    casestudy: "411383215",
    credits: [
      { title: "Year", text: "2018" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Short film in support of book Soviet Modernism. Brutalism. Post-modernism. Buildings and Projects in Ukraine 1960–1990 (Osnovy Publishing / DOM publishers). It's a wonderful representation of Kyiv's eclectic architectural beauty. Unfortunately we might be seeing the last of some of these outstanding buildings.`,
    highlights: [details8Image1, details8image2, details8image3],
    tvImage: ModernismGif,
  },
  {
    id: 9,
    movie: "246792785",
    credits: [
      { title: "Year", text: "2016" },
      { title: "Director", text: "Eugene Filatov" },
      { title: "Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
    ],
    story: `Music video for The Elephants.`,
    highlights: [details9Image1, details9image2, details9image3],
    tvImage: TheElephantsGif,
  },
  {
    id: 10,
    movie: "272547706",
    credits: [
      { title: "Year", text: "2018" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
    ],
    story: `Commercial for the #HeForShe campaign for UN Women Ukraine. Starring rock star Dmytro Shurov and his talented son Lev Shurov.`,
    highlights: [
      details10Image1,
      details10Image2,
      details10image3,
      details10image4,
      details10image5,
      details10image6,
    ],
    tvImage: HeForSheGif,
  },
  {
    id: 11,
    movie: "290874984",
    credits: [
      { title: "Year", text: "2018" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Commercial for Chernihiv City Council Tourism Board. Definitely a hot new weekend destination in Ukraine. We are proud that only local residents starred in this short.`,
    highlights: [details11Image1, details11image2, details11image3],
    tvImage: ChernihivGif,
  },
  {
    id: 12,
    movie: "272376959",
    credits: [
      { title: "Year", text: "2018" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Music/Sound: Anton Dehtiarov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Commercial for Concord Engineering GmbH (Concord Group). Showing Ukraine's industrial might. We filmed inside of the largest steel mill in Ukraine at the newest coke battery complex.`,
    highlights: [
      details12Image1,
      details12image2,
      details12image3,
      details12image4,
    ],
    tvImage: ConcordGif,
  },
  {
    id: 13,
    movie: "387976049",
    credits: [
      { title: "Year", text: "2019" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Spreading the message of hope and change in a political campaign ad for Serhiy Gusovsky for the Ukrainian 2019 Parliamentary election.`,
    highlights: [details13Image1, details13image2, details13image3],
    tvImage: GusovskyGif,
  },
  {
    id: 14,
    movie: "391940703",
    credits: [
      { title: "Year", text: "2020" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Commercial for Premier Food.`,
    highlights: [details14Image1, details14image2, details14image3],
    tvImage: MrGrillGif,
  },
  {
    id: 15,
    movie: "387974920",
    credits: [
      { title: "Year", text: "2019" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Alex Cherepanov" },
    ],
    story: `Go out and vote campaign for Holosuy. Our goal was to get young people excited about voting and politics.`,
    highlights: [details15Image1, details15image2, details15image3],
    tvImage: HolosuyGif,
  },
  {
    id: 16,
    movie: "394426829",
    credits: [
      { title: "Year", text: "2020" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "Design/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Anton Dehtiarov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `Commercial for Osnovy Publishing. Our goal was to create a powerful short video for the Publisher’s social media channels.`,
    highlights: [
      details16Image1,
      details16image2,
      details16image3,
      details16image4,
    ],
    tvImage: OsnovyGif,
  },
  {
    id: 17,
    movie: "411384793",
    credits: [
      { title: "Year", text: "2019" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
    ],
    story: `Go out and vote campaign for Holosuy. Our goal was to get young people excited about voting and politics. We created numerous short social media ads for Facebook and Instagram.`,
    highlights: [details17Image1, details17image2, details17image3],
    tvImage: WhyVoteGif,
  },
  {
    id: 18,
    movie: "411393824",
    credits: [
      { title: "Year", text: "2019" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
    ],
    story: `Go out and vote campaign for Holosuy. Our goal was to get young people excited about voting and politics. We created a fun and compelling video with Michael Schur, Ukraine’s top comedian, to promote voting amongst youths.`,
    highlights: [details18Image1, details18image2, details18image3],
    tvImage: ShchurGif,
  },

  {
    id: 19,
    movie: "423596373",
    credits: [
      { title: "Year", text: "2020" },
      { title: "Directors", text: "Roman Blazhan, Mikhail Volkov" },
      { title: "Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Anton Dehtiarov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `BEACHES OF KYIV is a short film by Roman Blazhan and Mikhail Volkov. It is a visual essay exploring Kyivan's favorite summer pastime. We take a journey through popular beaches, enjoying their seductive imagery. After many months in quarantine, the film is an ode to freedom and beauty that surrounds us.`,
    highlights: [
      details19Image1,
      details19image2,
      details19image3,
      details19image4,
      details19image5,
    ],
    tvImage: BeachesGif,
  },

  {
    id: 20,
    movie: "430274293",
    credits: [
      { title: "Year", text: "2020" },
      { title: "Directors", text: "Roman Blazhan, Mikhail Volkov" },
      { title: "Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music", text: "Anton Dehtiarov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `In August 2020, Osnovy Publishing will present their new publication, Orthodox Chic, a book about postmodern religious architecture in Ukraine. The authors of the book, architects Alex Bykov and Oleksandr Burlaka, alongside artist Sasha Kurmaz, turn to photographing post-Soviet religious architecture as a way of capturing its social, political and economic development. The book portrays new forms of religious architecture, from kiosks, shacks, pop-up chapels attached to giant shopping malls, apartment blocks and magnificent new cathedrals.

        Minimal Movie, a Kyiv-based production company and creative agency, were inspired by this topic and made a short film in support of the upcoming book.
        
        This short shows the frenzy of building religious architecture that occurred in independent Ukraine. This is encapsulated in one particular story: as a backdrop, whenever a temporary, ‘mini chapel’ has been installed on a particular site a large church is supposed to finally replace it. Father Petro (Peter) has been filing for planning permission and collecting money for the construction of the Church of St Peter and Paul for more than twenty years. Even if he doesn’t succeed in his lifetime, his son Pavlo (Paul), also a priest, will take over the work. This particular snapshot is just one of dozens of similar stories happening right now in Ukraine.
        
        Postmodern religious architecture in Ukraine can manifest itself in many, often surprising, ways: makeshift shacks near subway stations, a large neoclassical revival cathedral, or a chapel plonked on the top of a tower-block. The unique look of Ukrainian new religious architecture and the way it gets used is due to the way it has developed in complicated and ambiguous economic, social, and political conditions.
        
        For Roman Blazhan, the film’s director, and Mikhail Volkov, director of photography, the aim was to take a look at these often-unexamined forms of religious architecture, examples of which range from churches the size of kiosks and shacks, to pop-up chapels attached to giant shopping malls and apartment blocks, alongside magnificent new cathedrals. The music for the film was composed by Anton Dehtiarov.`,
    highlights: [
      details20Image1,
      details20image2,
      details20image3,
      details20image4,
      details20image5,
    ],
    tvImage: OrthodoxGif,
  },

  {
    id: 21,
    movie: "463785053",
    trailers: [
        {
          title: "Taras Makar",
          video: "463785761",
        },
        {
          title: "Maksim Kotsiuba",
          video: "463786049",
        },
      ],
    credits: [
      { title: "Year", text: "2020" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Anton Dehtiarov" },
      { title: "Concept/Idea", text: "Minimal Movie" },
    ],
    story: `A fun project we did for Ukrainian Young Book Design Awards and Acer Ukraine.  Starring WE BAD, Taras Makar and Maksim Kotsiuba.`,
    highlights: [
      details21Image1,
      details21image2,
      details21image3,
      details21image4,
      details21image5,
    ],
    tvImage: AcerGif,
  },

  {
    id: 22,
    movie: "464933140",
    credits: [
      { title: "Year", text: "2020" },
      { title: "Idea", text: "Maksym Kotsiuba" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Music/Sound", text: "Anton Dehtiarov" },
      { title: "Aerial DP", text: "Andrey Noga" },
      { title: "Photographer", text: "Maxim Goloborodko" },
      { title: "Produced by", text: "Minimal Movie" },
    ],
    story: `Soviet Union died twenty-nine years ago but the ghost of its totalitarian past lives on, most prominently in the very landscape of the country. The brutal architecture of soviet modernism remains in many cities in Ukraine, visually manifesting the bygone ideology of another era. What was supposed to become the past, continues to be the present. If urban spaces shape the values of its residents, what does it feel like to live in a post-soviet Ukraine today?

    To explore this question, Minimal Movie together with landscape architecture Maksim Kotsiuba, created a short film titled Landscape Architecture: Rethinking The Future out of a Totalitarian Past. The project explores the past, present, and future of urban spaces in Ukraine and captures the unique historical process of building new communities in the post-soviet landscape.`,
    highlights: [
      details22Image1,
      details22image2,
      details22image3,
      details22image4,
      details22image5,
      details22image6,
      details22image7,
    ],
    tvImage: LandscapeGif,
  },

  {
    id: 23,
    movie: "413941674",
    credits: [
      { title: "Year", text: "2020" },
      { title: "Director/Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mikhail Volkov" },
      { title: "Concept/Idea", text: "Minimal Movie" },

    ],
    story: `A touching story about artist and ethnic german, Harry Ruff. Project was created for Rat der Deutschen der Ukraine (The Council of Germans of Ukraine).`,
    highlights: [
      details23Image1,
      details23image2,
      details23image3,
      details23image4,
    ],
    tvImage: RuffGif,
  },

  {
    id: 24,
    movie: "868683888",
    credits: [
      { title: "Release date", text: "February 15, 2024" },
      { title: "Format", text: "Creative documentary" },
      { title: "Length", text: "80’/52'" },
      { title: "Language", text: "Ukrainian (English/French/German subtitles)" },
      { title: "Director", text: "Roman Blazhan" },
      { title: "Broadcaster", text: "ARTE" },
      { title: "Production companies", text: "Minimal Movie (Ukraine) + Elda Productions (France), co produced with  ARTE France" },
      { title: "Producers", text: "Roman Blazhan + Christilla Huillard-kann" },




    ],
    story: `What happens to us when we want to forget but the only way to move on is to remember.

    In early March 2022, Russian forces took control of the village of Yahidne in Northern Ukraine. They expelled the residents from their homes and confined them to the basement of the local school, which had been converted into a makeshift headquarters. The occupation lasted until March 30, 2022, during which time the Russians held the majority of Yahidne's population, comprising over 360 individuals, including 77 children, in a 198 square meter basement for nearly a month. Throughout the ordeal, Olha, a local resident, diligently documented their captivity in a diary. In the event that no one survives, this diary stands as a testament to the harrowing experiences endured during this period.`,
    highlights: [
      details24Image1,
      details24image2,
      details24image3,
      details24image4,
      details24image5,
      details24image6,
      details24image7,
    ],
    tvImage: Basement341Gif,
  },

  {
    id: 25,
    movie: "872919915",
    credits: [
      { title: "Format", text: "Creative documentary" },
      { title: "Length", text: "90’’" },
      { title: "Language", text: "German" },
      { title: "Director", text: "Lars Ksienzyk" },
      { title: "Producer", text: "Roman Blazhan" },
      { title: "Production companies", text: "Minimal Movie" },


    ],
    story: `Times change, and with them, people’s values, their perception of purpose change as well. In this intimate documentary, Lars, a 26-year old contemporary dancer from Germany, overlooks his previous ideals and sets off on a journey of self discovery. During this journey, Lars faces truly difficult and terrifying events, misunderstanding from his community and friends and gains a completely new perspective on life.`,
    highlights: [
      details25Image1,
      details25Image2,
      details25Image3,
    ],
    tvImage: TimeschangeGif,
  },

  {
    id: 26,
    movie: "872921786",
    credits: [
      { title: "Format", text: "Vertical documentary series" },
      { title: "Length", text: "8 x 25-30 minutes" },
      { title: "Language", text: "German" },
      { title: "Format", text: "Documentary" },
      { title: "Director", text: "Roman Blazhan" },
      { title: "Creative Producer", text: "Roman Blazhan" },
      { title: "Production companies", text: "Lailaps Films (a Studiocanal company),  Germany + Minimal Movie" },


    ],
    story: `What does home mean to someone who left their home country? How do people adapt to the new norms, rules in a society that’s new to them? In Germanising 101 we delve into the lives of people of different cultural backgrounds as they explore questions of identity, cultural stereotypes and behavior appropriation through their experience of living in Germany.`,
    highlights: [
      details26Image1,
      details26Image2,
      details26Image3,
    ],
    tvImage: Germanising101Gif,
  },
  
  {
    id: 27,
    movie: "746517840",
    credits: [
      { title: "Format", text: "vertical documentary series" },
      { title: "Length", text: "8 x 25-30 minutes" },
      { title: "Language", text: "English" },
      { title: "Directors", text: "Each episode is directed by a local female director from the region where the shooting takes place" },
      { title: "Production companies", text: "Lailaps Films (a Studiocanal company),  Germany + Minimal Movie" },
      { title: "Creative Producer", text: "Roman Blazhan" },
      { title: "Shooting locations", text: "Ukraine, the UK, South Africa, Germany, Poland, Saudi Arabia" },


    ],
    story: `Female esports athletes from around the globe showcase their creativity and bravery transforming the game into a performance through their unparalleled skills vast imagination and fierce persistence. They step onto the stage challenging norms and defying expectations showing the world how to "Play Like a Girl."`,
    highlights: [
      details27Image1,
      details27Image2,
      details27Image3,
    ],
    tvImage: PlaylikeagirlGif,
  },

  {
    id: 28,
    movie: "874705843",
    credits: [
      { title: "Format", text: "Creative documentary" },
      { title: "Length", text: "90'" },
      { title: "Language", text: "Ukrainian" },
      { title: "Director", text: "Roman Blazhan" },
      { title: "Producer", text: "Roman Blazhan" },
      { title: "Production company", text: "Minimal Movie" },


    ],
    story: `A photographer’s search for a girl from a career-defining photograph, becomes the journey to find his home, lost in time and war.`,
    highlights: [
      details28Image1,
      details28Image2,
      details28Image3,
      details28Image4,
      details28Image5,      
    ],
    tvImage: SearchforaPokemonGif,
  },

  {
    id: 29,
    movie: "866303328",
    credits: [
      { title: "Release date", text: "May 8, 2023" },
      { title: "Format", text: "Creative documentary" },
      { title: "Length", text: "52’" },
      { title: "Language", text: "Ukrainian (eng sub)" },
      { title: "Directors", text: "Mykhailo Volkov & Roman Blazhan" },
      { title: "Idea", text: "Katia Heinrich" },
      { title: "Partners", text: "International Association for Education and Exchange (IBB e.V.)" },
      { title: "Producer", text: "Roman Blazhan" },

    ],
    story: `A film about light, made in the darkness. Generation Ukraine is a testament to the resilience of the young Ukrainian generation, their unwavering bond with their homeland, and their determination to find light in the most challenging of times. This captivating documentary reveals that even in the darkest hour, hope still flickers, and the dawn of a brighter future is on the horizon.`,
    highlights: [
      details29Image1,
      details29Image2,
      details29Image3,
      details29Image4,
      details29Image5,
      details29Image6,      
    ],
    tvImage: GenerationUkraineGif,
  },

  {
    id: 30,
    movie: "832548437",
    credits: [
      { title: "Format", text: "Creative Documentary short" },
      { title: "Length", text: "10’’" },
      { title: "Language", text: "Ukrainian (eng sub)" },
      { title: "Director", text: "Mykhailo Volkov" },
      { title: "Producer", text: "Roman Blazhan" },
      { title: "DOP/Edit", text: "Mykhailo Volkov" },
      { title: "Partners", text: "Nowness, Takflix" },

    ],
    story: `From late 1940-s to late 1980-s doves were an obsession for boys in Kyiv. This is a film about how a hobby from childhood becomes a meaning of life. Created with Takflix and Nowness.`,
    highlights: [
      details30Image1,
      details30Image2,
      details30Image3,
      details30Image4,
    ],
    tvImage: DovecotesofKyivGif,
  },


  // {
  //     id: 119,
  //     movie: "394426829",
  //     credits: [
  //         { title: "Year", text: "2019"},
  //         { title: "Director/Producer", text: "Roman Blazhan"},
  //         { title: "DOP/Edit", text: "Mikhail Volkov"},
  //         { title: "Music", text: "Alex Che"},
  //     ],
  //     story: `Sample story.`,
  //     highlights: ["411383215","411392158","411396716"],
  //     highlightsIsVideo:true,
  //     },
];
